var _path, _g, _path2, _g2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 221,
    viewBox: "0 0 194 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_53_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 194,
    height: 221
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H193.023V220.135H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_53_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.937 42.9953C168.786 41.8951 167.818 41.2882 167.021 41.2186C166.225 41.1554 149.368 39.9035 149.368 39.9035C149.368 39.9035 137.665 28.2821 136.375 26.9923C135.091 25.7088 132.581 26.1008 131.607 26.3853C131.462 26.4296 129.047 27.1757 125.057 28.4086C121.143 17.154 114.239 6.81621 102.099 6.81621C101.764 6.81621 101.416 6.82885 101.075 6.84782C97.6223 2.28275 93.3418 0.297394 89.6492 0.297394C61.361 0.297394 47.8492 35.6545 43.6129 53.624C32.6238 57.032 24.8152 59.4473 23.8162 59.7634C17.683 61.6855 17.487 61.8815 16.684 67.6606C16.077 72.036 0.0234375 196.178 0.0234375 196.178L125.108 219.61L192.875 204.948C192.875 204.948 169.089 44.1018 168.937 42.9953ZM118.14 30.5457L107.555 33.8209C107.562 33.0748 107.562 32.3414 107.562 31.5384C107.562 24.5454 106.594 18.9181 105.039 14.4542C111.292 15.2382 115.459 22.3577 118.14 30.5457ZM97.2746 15.8389C99.0133 20.1953 100.145 26.4549 100.145 34.8895C100.145 35.3258 100.139 35.7178 100.139 36.1161C93.2533 38.2532 85.7734 40.5674 78.2808 42.8878C82.4855 26.6445 90.3764 18.7979 97.2746 15.8389ZM88.8715 7.88476C90.0919 7.88476 91.3248 8.29575 92.5008 9.11139C83.4339 13.373 73.7158 24.1154 69.6123 45.5687L52.3384 50.9241C57.1437 34.5607 68.5564 7.88476 88.8715 7.88476Z",
    fill: "#8AC13F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_53_128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 124,
    y: 25,
    width: 70,
    height: 196
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.523 25.8981H193.025V220.135H124.523V25.8981Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_53_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.024 41.2184C166.227 41.1551 149.371 39.9032 149.371 39.9032C149.371 39.9032 137.667 28.2819 136.377 26.992C135.897 26.5178 135.252 26.2712 134.569 26.1638L125.116 219.61L192.878 204.948C192.878 204.948 169.091 44.1016 168.94 42.9951C168.788 41.8949 167.82 41.2879 167.024 41.2184Z",
    fill: "#8AC13F"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102 79.2384L93.5826 103.814C93.5826 103.814 86.2093 99.9506 77.1743 99.9506C63.9241 99.9506 63.2556 108.115 63.2556 110.172C63.2556 121.4 93.0604 125.702 93.0604 151.99C93.0604 172.677 79.6957 186 61.6765 186C40.0598 186 29 172.79 29 172.79L34.7878 154.01C34.7878 154.01 46.1532 163.587 55.7486 163.587C62.014 163.587 64.5608 158.742 64.5608 155.204C64.5608 140.562 40.1108 139.906 40.1108 115.849C40.1108 95.5931 54.9145 76 84.7958 76C96.3141 76 102 79.2384 102 79.2384Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopify);
export default __webpack_public_path__ + "static/media/Shopify.62c4f935ae7488cd3cf4c60584c80851.svg";
export { ForwardRef as ReactComponent };